module.exports = __webpack_public_path__ + "media/images/help/cb-license-review-ecfdb7ae144491d25b8cd7d6dfa8e303.png";